export const easeOutCubic = (t: number) => 1 - Math.pow(1 - t, 3);
export const easeInOutCubic = (t: number) => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;

/** Runs `onUpdate(progress)` every frame for `duration` ms. Resolves early if cancelled. */
export function tween(duration: number, onUpdate: (k: number) => void, isCancelled: () => boolean): Promise<void> {
  return new Promise((resolve) => {
    const start = performance.now();
    const step = () => {
      if (isCancelled()) return resolve();
      const k = Math.min(1, (performance.now() - start) / duration);
      onUpdate(k);
      if (k < 1) requestAnimationFrame(step);else
      resolve();
    };
    requestAnimationFrame(step);
  });
}

export const nextFrame = () => new Promise<void>((r) => requestAnimationFrame(() => r()));
